var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_right"},[_vm._v("update:"+_vm._s(_vm.update))])
}
var staticRenderFns = []

export { render, staticRenderFns }